module.exports = __webpack_public_path__ + "img/activity_5_criminal_splash.5aa6eb98.jpg";